import React, { forwardRef } from 'react';
import { AppContext, IAppContext } from './context';

const withContextProps = <P extends IAppContext>(WrappedComponent: React.ComponentType<P>) => {
  return forwardRef((props: Omit<P, keyof IAppContext>, ref) => {
    return (
      <AppContext.Consumer>
        {(languageProps) => {
          return <WrappedComponent ref={ref} {...(props as P)} {...languageProps} />;
        }}
      </AppContext.Consumer>
    );
  });
};

export default withContextProps;
